<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    floating
    persistent
    mobile-break-point="991"
    width="300"
    absolute
  >
    <v-img
      :src="image"
      height="100%">
      <v-layout
        class="fill-height"
        tag="v-list"
        column>
        <v-list-tile avatar>
          <v-list-tile-avatar color="transparent">
            <v-img :src="logo" />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            HERON Energy Control
          </v-list-tile-title>
        </v-list-tile>
        <v-divider />
        <!-- <v-list-tile v-if="responsive">
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="purple"
          />
        </v-list-tile> -->
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="link.text" />
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from 'vuex'

export default {
  data: () => ({
    logo: require('@/assets/img/energy-control.png'),
    links: [
      {
        to: '/home',
        icon: 'mdi-view-dashboard',
        text: 'Home'
      },
      {
        to: '/matching',
        icon: 'mdi-link',
        text: 'Matching'
      },
      {
        to: '/users',
        icon: 'mdi-account',
        text: 'Users'
      },
      {
        to: '/homes',
        icon: 'mdi-home',
        text: 'Homes'
      },
      {
        to: '/meters',
        icon: 'mdi-speedometer',
        text: 'Devices'
      },
      {
        to: '/projects',
        icon: 'mdi-file-document',
        text: 'Projects'
      }
    ],
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
